import React, { useEffect, useMemo, useState } from 'react'
import { DetalleParametrosPlanificacionHE } from '../TypesParametrosHorasExtras'

import { Card, CardTitle, CardBody, Row, Col, Input, Label } from "reactstrap"
import { useParametrosMensualesHorasExtrasContext } from 'Context/ParametrosMensualesHorasExtrasContext'
import DatePickerBlueColor from 'components/Varios/DatePicker/DatePickerBlueColor'
import { isWeekday } from 'functions/CalendarFunctions'
import MonthDatePicker from 'components/Varios/DatePicker/MonthDatePicker'
import { showAlert } from '../Actividades/ActividadesHorasExtras'

type PropsCardPeriodosPlanificacioneHE = {
    parametros: DetalleParametrosPlanificacionHE | null | undefined,
    onChangeValorDias: (valor: any, tipo: string) => void
}

export default function CardPeriodosPlanificacionHE(props: PropsCardPeriodosPlanificacioneHE) {



    const [diaRecepcionPlanificacion, setdiaRecepcionPlanificacion] = useState<number | null>(null)
    const [diaRecepcionSolicitud, setdiaRecepcionSolicitud] = useState<number | null>(null)
    const [minminutoshe, setminminutoshe] = useState<number | null>(null)
    // const [mesExtr, setmesExtr] = useState<number | null>(null)
    const [mesExtr, setmesExtr] = useState<Date | null>(null)
    const [fechaMaxExtr, setfechaMaxExtr] = useState<string | null | Date>(null)

    const {
        guardandoParametro,
    } = useParametrosMensualesHorasExtrasContext();

    const disabledGeneral = guardandoParametro

    useEffect(() => {


        if (props.parametros && props.parametros.diaMaximoRecepcionPlanificacion) {
            setdiaRecepcionPlanificacion(props.parametros.diaMaximoRecepcionPlanificacion);
        }
        else {
            setdiaRecepcionPlanificacion(null)
        }

        if (props.parametros && props.parametros.diaMaximoRecepcionSolicitud) {
            setdiaRecepcionSolicitud(props.parametros.diaMaximoRecepcionSolicitud);
        }
        else {
            setdiaRecepcionSolicitud(null)
        }

        // if (props.parametros && props.parametros.mesPeriodoExtr) {

        //     const mesaUsar = props.parametros.mesPeriodoExtr;
        //     const anioaUsar = props.parametros.anio;
        //     const fechaAUsar = new Date(anioaUsar,mesaUsar,1,0,0,0,0);

        //     setmesExtr(fechaAUsar);
        // }
        // else {
        //     setmesExtr(null);
        // }

        if (props.parametros && props.parametros.fechaMaximaPeriodoExtr) {
            setfechaMaxExtr(props.parametros.fechaMaximaPeriodoExtr);
        }
        else {
            setfechaMaxExtr(null);
        }

        if (props.parametros && props.parametros.minMinutosHorExtr) {
            setminminutoshe(props.parametros.minMinutosHorExtr)
        }
        else {
            setminminutoshe(null)
        }




    }, [props.parametros])


    useEffect(() => {
        if (props.parametros && props.parametros.mesPeriodoExtr) {
            //Se disminuye en 1, porque el mes que se esta devolviendo del servicio es 1 numero mayor al del indice de TS/JS
            const mesaUsar = props.parametros.mesPeriodoExtr - 1;
            const anioaUsar = props.parametros.anio;
            const fechaAUsar = new Date(anioaUsar, mesaUsar, 1, 0, 0, 0, 0);

            setmesExtr(fechaAUsar);
        }
    }, [props.parametros?.mesPeriodoExtr])



    function onChangeValue(e: any, tipo: "P" | "S" | "PE" | "M" | "PEF") {
        if (tipo === "PE") {

            const primerFechaDelMes: Date = e;

            if (primerFechaDelMes) {
                console.log("cambiando el valor del mes" + primerFechaDelMes.toString())
            }

            setmesExtr(primerFechaDelMes)
            CallOnChangeValorFunction(primerFechaDelMes,tipo)

        }
        else if (tipo === "PEF"){
            const fecha: Date | null = e;
            
            setfechaMaxExtr(e)
            CallOnChangeValorFunction(fecha,tipo)
        }
        else {
            var valor = e.target.value

            if (valor) {
                valor = +valor;
            }

            if (tipo === "P") {
                setdiaRecepcionPlanificacion(valor)
                
            }

            if (tipo === "S") {
                setdiaRecepcionSolicitud(valor)
            }

            if (tipo === "M") {


                if (valor < 0) {
                    showAlert("El valor no puede ser menor a 0", false)
                    return;
                }

                setminminutoshe(valor)
                CallOnChangeValorFunction(valor,tipo)
            }
        }

    }

    function CallOnChangeValorFunction(valor: any, tipo: string) {

        if (tipo === "PE") {

            if (valor !== null && valor instanceof Date) {

                const mes: number = valor.getMonth() + 1;
                props.onChangeValorDias(mes, "PE")
            }
            else {
                props.onChangeValorDias(null, "PE")
            }
        }

        if (tipo === "PEF") {
            if (valor !== null) {
                if (valor instanceof Date) {
                    props.onChangeValorDias(valor.toISOString(), "PEF")
                }
                else {
                    props.onChangeValorDias(valor, "PEF")
                }

            }
            else {
                props.onChangeValorDias(null, "PEF")
            }
        }



        if (tipo === "M") {
            if (valor !== null && typeof valor === "number") {
                props.onChangeValorDias(valor, "M")
            }
            else {
                props.onChangeValorDias(null, "M")
            }
        }


    }

    useEffect(() => {
        if (diaRecepcionPlanificacion !== null) {
            props.onChangeValorDias(diaRecepcionPlanificacion, "P")
        }
    }, [diaRecepcionPlanificacion])




    useEffect(() => {
        if (diaRecepcionSolicitud !== null) {
            props.onChangeValorDias(diaRecepcionSolicitud, "S")
        }
    }, [diaRecepcionSolicitud])

    // useEffect(() => {
    //     if (mesExtr !== null) {

    //         const mes: number = mesExtr.getMonth() + 1;
    //         props.onChangeValorDias(mes, "PE")
    //     }
    //     // else{
    //     //     props.onChangeValorDias(null, "PE")
    //     // }
    // }, [mesExtr])

    // useEffect(() => {
    //     if (fechaMaxExtr !== null) {
    //         if (fechaMaxExtr instanceof Date) {
    //             props.onChangeValorDias(fechaMaxExtr.toISOString(), "PEF")
    //         }
    //         else {
    //             props.onChangeValorDias(fechaMaxExtr, "PEF")
    //         }

    //     }
    //     // else {
    //     //     props.onChangeValorDias(null, "PEF")
    //     // }
    // }, [fechaMaxExtr])

    // useEffect(() => {
    //     if (minminutoshe !== null) {


    //         props.onChangeValorDias(minminutoshe, "M")
    //     }
    // }, [minminutoshe])







    const DatePickerFechaMaxExtr = useMemo(() => {



        return (
            <DatePickerBlueColor
                value={fechaMaxExtr}
                disabled={false}
                name="fechaMaxExtr"
                id="fechaMaxExtr"
                //onChange={(e) => { setfechaMaxExtr(e) }}
                onChange={(e) => { onChangeValue(e,"PEF") }}
                filter={(date: Date) => isWeekday(date)}
                monthdropdown={true}
            />
        )


    }, [fechaMaxExtr])


    return (
        <Card className="">
            <CardTitle className="cardHeaderParametrosPeriodos"> <span className='pl-3'>
                Periodos
                <span className='pl-3'>
                    <i
                        className="fas fa-info-circle"

                    />
                </span>

            </span></CardTitle>
            <CardBody className="cardBodyParametrosPeriodos">
                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}>Día límite del mes para la recepción de la planificación mensual de horas extras</span>
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col xl={6}>
                        <Label>
                            {"Día (de cada mes en curso)"}
                        </Label>
                        <Input
                            value={!diaRecepcionPlanificacion ? "" : diaRecepcionPlanificacion}
                            onChange={(e) => { onChangeValue(e, "P") }}
                            type="number"
                            disabled={disabledGeneral}
                        /></Col>
                </Row>

                <Row className={"mt-2"}>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}>Periodo extraordinario para recepción de la planificación mensual de horas extras</span>
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col xl={6}>
                        <Label>
                            {"Fecha"}
                        </Label>
                        {DatePickerFechaMaxExtr}
                    </Col>
                    <Col xl={6}>
                        <Label>
                            {"Mes de planificación"}
                        </Label>
                        {/* <Input
                            value={mesExtr ?? ""}
                            onChange={(e) => { onChangeValue(e, "PE") }}
                            type="number"
                            disabled={disabledGeneral}
                        /> */}
                        <MonthDatePicker
                            value={mesExtr}
                            onChange={(fecha: any) => { onChangeValue(fecha, "PE") }}
                            color='blue'
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}>Día límite del mes para la recepción de la solicitud para el pago de las horas extras</span>
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col xl={6}>
                        <Label>
                            {"Día"}
                        </Label>
                        <Input
                            value={diaRecepcionSolicitud ?? ""}
                            onChange={(e) => { onChangeValue(e, "S") }}
                            type="number"
                            disabled={disabledGeneral}
                        /></Col>
                </Row>

                <Row className={"mt-1"}>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}>Mínimo de minutos para solicitar horas extras</span>
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col xl={6}>
                        <Label>
                            {"Minutos"}
                        </Label>
                        <Input
                            value={minminutoshe ?? ""}
                            onChange={(e) => { onChangeValue(e, "M") }}
                            type="number"
                            disabled={disabledGeneral}
                        /></Col>
                </Row>
            </CardBody>
        </Card>
    )
}
